import { useState } from "react";
import { useQuery } from "@tanstack/react-query";

import { exportApi } from "../api/export";

export const useExport = () => {

    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(25);

    const [downloadingFileId, setDownloadingFileId] = useState<string | null>(null);

    const { data, isLoading, isSuccess, isError, refetch, isRefetching } = useQuery({
        queryKey: ["export-data", page, limit],
        queryFn: () => exportApi.fetchExport({ page, limit }),
    });

    const changePage = (page: number) => {
        setPage(page);
    };

    const changeRowsPerPage = (limit: number) => {
        setLimit(limit);
    };

    const handleDownloadFile = async (objectRefId: { export_name: string, create_date: string, object_ref_id: string }) => {
        try {
            setDownloadingFileId(objectRefId.object_ref_id);
            const response = await exportApi.downloadExport(objectRefId.object_ref_id);
            const url = window.URL.createObjectURL(new Blob([response]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${objectRefId.export_name}_${objectRefId.create_date}.csv`);
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            console.error("Error downloading file:", error);
        } finally {
            setDownloadingFileId(null);
        }
    };

    return {
        data: isSuccess ? data.data.rows : [],
        pagination: isSuccess ? data.data.pagination : { total: 0, limit: 25, page: 1 },
        isLoading: isLoading || isRefetching,
        isError,
        refetch,
        changePage,
        changeRowsPerPage,
        downloadingFileId,
        handleDownloadFile
    }

};